import React from 'react';
import SecondaryButton from "./SecondaryButton";
import SaveDropdownButton from "./SaveDropdownButton";

const AppointmentFormFooter = ({
  secondaryCaption,
  secondaryClickHandler,
  onSave,
  onSaveAndEmail,
  isLoading = false,
  disabled = false,
  requiresVerification = false,
  verificationMessage,
  mode, // Can be used to conditionally show save options based on create/update mode
}) => {
  return (
    <div className="mt-6 border-t border-ink-100 pt-6">
      <div className="flex items-center justify-end gap-x-6">
        {secondaryCaption && (
          <SecondaryButton
            onClick={secondaryClickHandler}
            colour="gray"
            disabled={isLoading}
          >
            {secondaryCaption}
          </SecondaryButton>
        )}
        <SaveDropdownButton
          onSave={onSave}
          onSaveAndEmail={onSaveAndEmail}
          disabled={disabled}
          isLoading={isLoading}
          requiresVerification={requiresVerification}
          verificationMessage={verificationMessage}
        />
      </div>
    </div>
  );
};

export default AppointmentFormFooter;